import { createPortal } from 'react-dom';
import { ArrowRight, X } from 'lucide-react';
import '@/pages/GuestDashboard.css';

const DEFAULT_LABELS = {
  survey: { es: 'Responder encuesta', en: 'Take survey' },
  benefit: { es: 'Ver beneficios', en: 'View benefits' },
  info: { es: 'Entendido', en: 'Got it' },
};

// Modal informativo reutilizable para huéspedes. Sigue el lenguaje visual del
// modal de bienvenida ("Bienvenido a Wanna Colive"): superficie, eyebrow,
// título y un CTA principal. El flyer va arriba, limitado en altura para que
// el modal no quede excesivamente largo en vertical.
function InfoPopupModal({ popup, language, onClose, onAction }) {
  const es = language === 'es';
  const isInfo = popup.cta_type === 'info';
  const label =
    popup.cta_label ||
    (es ? DEFAULT_LABELS[popup.cta_type]?.es : DEFAULT_LABELS[popup.cta_type]?.en) ||
    (es ? 'Continuar' : 'Continue');

  const handleCta = () => {
    if (isInfo) onClose();
    else onAction(popup.cta_type);
  };

  return createPortal(
    <div
      className="fixed inset-0 z-50 modal-backdrop"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      data-testid="info-popup-modal"
    >
      <div className="popup-modal__card modal-card relative flex max-w-md flex-col overflow-hidden rounded-2xl border border-border bg-surface shadow-xl">
        <button
          type="button"
          onClick={onClose}
          className="popup-modal__close"
          aria-label={es ? 'Cerrar' : 'Close'}
          data-testid="info-popup-close"
        >
          <X className="h-5 w-5" />
        </button>

        {popup.image_url && (
          <div className="popup-modal__image-wrap shrink-0">
            <img src={popup.image_url} alt="" className="popup-modal__image" />
          </div>
        )}

        <div className="popup-modal__body overflow-y-auto px-5 py-5 text-center">
          <p className="popup-modal__eyebrow">{es ? 'WANNACOLIVE' : 'WANNACOLIVE'}</p>
          <h2 className="font-heading text-lg font-bold leading-6 text-foreground">{popup.title}</h2>
          {popup.body && (
            <p className="mt-2 whitespace-pre-line text-sm leading-5 text-muted-foreground">{popup.body}</p>
          )}
        </div>

        <div className="shrink-0 border-t border-border px-5 py-4">
          <button
            type="button"
            onClick={handleCta}
            className="popup-modal__cta"
            data-testid="info-popup-cta"
          >
            {label}
            {!isInfo && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
          </button>
          {isInfo && (
            <button
              type="button"
              onClick={onClose}
              className="mt-2 w-full text-center text-xs font-medium text-muted-foreground transition hover:text-foreground"
            >
              {es ? 'Cerrar' : 'Close'}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default InfoPopupModal;
